import { render, staticRenderFns } from "./PaginationButtonContent.vue?vue&type=template&id=50d8ae4c&"
import script from "./PaginationButtonContent.vue?vue&type=script&lang=js&"
export * from "./PaginationButtonContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports